import React, {useContext, useEffect} from 'react';
import './MillworksContent.scss';
import {ExperienceContext, useStore} from '@thd-nucleus/experience-context';

const MillworksContent = () => {
  const { storeId } = useStore({ varnish: false });
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel !== 'mobile';
  useEffect(() => {
    if(storeId) {
      initializeMillworks(storeId, isMobile);
    }
  }, storeId);
  return null;
};

export const initializeMillworks = (storeId, isMobile) => {
  const channel = isMobile ? 'mobile' : 'desktop';
  const channelConfig = getChannelConfig(channel);

  if(channelConfig) {
    window.revjet = window.revjet || {};
    window.revjet.tags = window.revjet.tags || [];

    window.revjet.tags.push({
      _tag: channelConfig.tagID,
      _plc_id: channelConfig.placmentId,
      _key: channelConfig.key,
      _opts: {
        embd_tag_id: (function(doc) {
          var tag = doc.createElement("div");
          tag.id = 'revjet-tag-' + revjet.tags.length;
          var s = doc.getElementsByTagName("script");
          s[s.length-1].parentNode.insertBefore(tag, s[s.length-1]);
          return tag.id;
        })(document),
        responsive: channelConfig.responsive,
        autoscale: channelConfig.autoscale,
        delivery_method: channelConfig.deliveryMethod,
        _imp_banner_size: channelConfig.size
      },
      thd_store_id: storeId
    });

    (function(a,d){var b=d.createElement(a);b.asyc=!0;b.type="text/javascript";
      b.src="https://rma.homedepot.com/bg";
      a=d.getElementsByTagName(a)[0];a.parentNode.insertBefore(b,a)})("script",document);
  }
}

export const getChannelConfig = (channel) => {
  const defaults = {
    responsive: false,
    autoscale: true,
    deliveryMethod: 'banner'
  }
  const config = {
    mobile: {
      placmentId: '48146786',
      size: '375x450',
      tagID: 'tag154512',
      key: '298'
    },
    desktop: {
      placmentId: '48146666',
      size: '1420x350',
      tagID: 'tag154511',
      key: '4c3'
    }
  }
  return {...defaults, ...config[channel]};
}

export default MillworksContent;
